console.log('js/events.js -> v0.1.0');

$.fn.bindFirst = function(name, fn) {
    this.bind(name, fn)
    var handlers = $._data($(this).get(0), 'events')[name.split('.')[0]];
    var handler = handlers.pop();
    handlers.splice(0, 0, handler);
};
